import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { FavoritarStateModel } from '..';
import { Favorito } from '../actions/favoritar.action';

@State<FavoritarStateModel[]>({
    name: 'favoritosStore',
    defaults: [
        {
            id: null,
            date: null,
            type: null,
            title: {
                rendered: null,
            },
            image: null,
        },
    ],
})
@Injectable({
    providedIn: 'root',
})
export class FavoritosState {
    @Selector()
    static getFavoritoById(state: FavoritarStateModel[]): FavoritarStateModel[] {
        return state;
    }

    @Selector()
    static getAllFavorito(state: FavoritarStateModel[]): FavoritarStateModel[] {
        return state;
    }

    @Action(Favorito.Add)
    AddFavorito({ patchState }: StateContext<FavoritarStateModel>, { payload }: Favorito.Add) {
        patchState({
            id: payload.id,
            date: payload.date,
            title: { rendered: payload?.title?.rendered },
            image: payload.image || null,
            type: payload.type || '',
        });
    }

    @Action(Favorito.Delete)
    deleteFavorito({ patchState }: StateContext<FavoritarStateModel>, { id }: Favorito.Delete) {
        patchState({
            id,
        });
    }
}
